import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { memoGeneric } from '@/js/libs/memo/index.ts';
import { Tag } from '../../Elements/Tag/index.js';
import { TabWrapper, Title } from './styled.js';
export const TabItem = memoGeneric(function TabItem({ item, active, onTabChange }) {
    const handleClick = useCallbackRef(() => {
        onTabChange(item.id);
    });
    const dataTestId = item.dataTestId || `${item.id}-tab`;
    if (item.hidden) {
        return null;
    }
    return (_jsxs(TabWrapper, { $active: active, onClick: handleClick, "data-testid": dataTestId, "data-active": active, children: [_jsx(Title, { $active: active, children: item.title }), item.label && _jsx(Tag, { title: item.label })] }));
});
